
import React from 'react';

const Process: React.FC = () => {
  return (
    <section id="process" className="py-20 bg-white section-padding">
      <div className="container-width">
        <div className="text-center mb-16">
          <span className="inline-block px-3 py-1 bg-presintention-accent/10 text-presintention-accent rounded-full text-sm font-medium mb-4 fade-in-view">
            Our Process
          </span>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 fade-in-view text-presintention-dark">
            How We <span className="text-presintention-accent">Transform</span> Your Presentations
          </h2>
          <p className="max-w-2xl mx-auto text-presintention-dark/70 text-lg fade-in-view">
            Our proven methodology takes you from concept to confident delivery with personalized guidance at every step.
          </p>
        </div>
        
        <div className="relative mt-16">
          {/* Timeline */}
          <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-presintention-border" />
          
          {/* Timeline Steps */}
          <div className="space-y-16 md:space-y-0 relative z-10">
            {/* Step 1 */}
            <div className="md:grid md:grid-cols-2 md:gap-8 items-center mb-16">
              <div className="md:text-right fade-in-view">
                <div className="md:pr-8 relative">
                  <div className="hidden md:block absolute top-3 right-0 w-8 h-1 bg-presintention-border" />
                  <div className="hidden md:block absolute top-0 right-[-8px] w-6 h-6 rounded-full bg-presintention-accent border-4 border-white shadow-md" />
                  <span className="inline-block px-2 py-1 bg-presintention-accent text-white text-xs font-bold rounded mb-2">
                    STEP 1
                  </span>
                  <h3 className="text-xl font-bold mb-2 text-presintention-dark">Strategic Assessment</h3>
                  <p className="text-presintention-dark/70">
                    We begin with a comprehensive analysis of your presentation goals, audience, and current skills to create a personalized coaching plan.
                  </p>
                </div>
              </div>
              <div className="mt-8 md:mt-0 md:pl-8 fade-in-view">
                <div className="bg-presintention-light rounded-xl overflow-hidden">
                  <img 
                    src="https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80" 
                    alt="Strategic assessment process" 
                    className="w-full h-60 object-cover"
                  />
                </div>
              </div>
            </div>
            
            {/* Step 2 */}
            <div className="md:grid md:grid-cols-2 md:gap-8 items-center mb-16">
              <div className="md:order-2 fade-in-view">
                <div className="md:pl-8 relative">
                  <div className="hidden md:block absolute top-3 left-0 w-8 h-1 bg-presintention-border" />
                  <div className="hidden md:block absolute top-0 left-[-8px] w-6 h-6 rounded-full bg-presintention-accent border-4 border-white shadow-md" />
                  <span className="inline-block px-2 py-1 bg-presintention-accent text-white text-xs font-bold rounded mb-2">
                    STEP 2
                  </span>
                  <h3 className="text-xl font-bold mb-2 text-presintention-dark">Content Development</h3>
                  <p className="text-presintention-dark/70">
                    We help you craft a compelling narrative, refine your key messages, and design visuals that enhance rather than distract from your presentation.
                  </p>
                </div>
              </div>
              <div className="mt-8 md:mt-0 md:pr-8 md:order-1 fade-in-view">
                <div className="bg-presintention-light rounded-xl overflow-hidden">
                  <img 
                    src="https://images.unsplash.com/photo-1434030216411-0b793f4b4173?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80" 
                    alt="Content development process" 
                    className="w-full h-60 object-cover"
                  />
                </div>
              </div>
            </div>
            
            {/* Step 3 */}
            <div className="md:grid md:grid-cols-2 md:gap-8 items-center mb-16">
              <div className="md:text-right fade-in-view">
                <div className="md:pr-8 relative">
                  <div className="hidden md:block absolute top-3 right-0 w-8 h-1 bg-presintention-border" />
                  <div className="hidden md:block absolute top-0 right-[-8px] w-6 h-6 rounded-full bg-presintention-accent border-4 border-white shadow-md" />
                  <span className="inline-block px-2 py-1 bg-presintention-accent text-white text-xs font-bold rounded mb-2">
                    STEP 3
                  </span>
                  <h3 className="text-xl font-bold mb-2 text-presintention-dark">Delivery Coaching</h3>
                  <p className="text-presintention-dark/70">
                    Through targeted exercises and video analysis, we refine your delivery style, body language, and vocal techniques to maximize your impact.
                  </p>
                </div>
              </div>
              <div className="mt-8 md:mt-0 md:pl-8 fade-in-view">
                <div className="bg-presintention-light rounded-xl overflow-hidden">
                  <img 
                    src="https://images.unsplash.com/photo-1560439513-74b037a25d84?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80" 
                    alt="Delivery coaching session" 
                    className="w-full h-60 object-cover"
                  />
                </div>
              </div>
            </div>
            
            {/* Step 4 */}
            <div className="md:grid md:grid-cols-2 md:gap-8 items-center">
              <div className="md:order-2 fade-in-view">
                <div className="md:pl-8 relative">
                  <div className="hidden md:block absolute top-3 left-0 w-8 h-1 bg-presintention-border" />
                  <div className="hidden md:block absolute top-0 left-[-8px] w-6 h-6 rounded-full bg-presintention-accent border-4 border-white shadow-md" />
                  <span className="inline-block px-2 py-1 bg-presintention-accent text-white text-xs font-bold rounded mb-2">
                    STEP 4
                  </span>
                  <h3 className="text-xl font-bold mb-2 text-presintention-dark">Feedback & Refinement</h3>
                  <p className="text-presintention-dark/70">
                    Through multiple practice sessions and detailed feedback, we help you refine your presentation until it achieves your specific goals.
                  </p>
                </div>
              </div>
              <div className="mt-8 md:mt-0 md:pr-8 md:order-1 fade-in-view">
                <div className="bg-presintention-light rounded-xl overflow-hidden">
                  <img 
                    src="https://images.unsplash.com/photo-1556761175-b413da4baf72?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80" 
                    alt="Feedback and refinement process" 
                    className="w-full h-60 object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
